import React, { useMemo } from 'react'
import { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import { Card, Button, Space } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { IDataByDay } from '../../model/selectors'
import { getDetailTaskItemData } from '../../model/services/getDetailTaskItemData'
import { TaskDetailCard } from '../task-detail-card'
import {
  Container,
  Header,
  DateInfo,
  Weekday,
  Date as StyledDate,
  Day,
  Month,
  Stats,
  Content,
  TasksList,
  NoTasks,
  NoTasksIcon,
  NoTasksText
} from './styles'

interface DayViewProps {
  value: Dayjs
  dataByDay: IDataByDay
  isTimeTableViewMode: boolean
  onValueChange?: (newValue: Dayjs) => void
}

export const DayView: React.FC<DayViewProps> = ({
  value,
  dataByDay,
  isTimeTableViewMode,
  onValueChange,
}) => {
  const today = dayjs()
  const isToday = value.isSame(today, 'day')

  const detailData = useMemo(() => {
    return getDetailTaskItemData(value, dataByDay)
  }, [value, dataByDay])


  const handlePrevDay = () => {
    const newValue = value.subtract(1, 'day')
    onValueChange?.(newValue)
  }

  const handleNextDay = () => {
    const newValue = value.add(1, 'day')
    onValueChange?.(newValue)
  }

  const handleToday = () => {
    onValueChange?.(dayjs())
  }

  return (
    <Container>
      <Header>
        <DateInfo>
          <Weekday>{value.format('dddd')}</Weekday>
          <StyledDate>
            <Day>{value.format('D')}</Day>
            <Month>{value.format('MMMM YYYY')}</Month>
          </StyledDate>
        </DateInfo>
        <Stats>
          <Space>
            <Button onClick={handleToday}>Сегодня</Button>
            <Button size='small' icon={<LeftOutlined />} onClick={handlePrevDay} />
            <Button size='small' icon={<RightOutlined />} onClick={handleNextDay} />
          </Space>
        </Stats>
      </Header>

      <TasksList>
        {detailData && detailData.length > 0 ? (
          detailData.map((task) => (
            <TaskDetailCard key={task.id} task={task} />
          ))
        ) : (
          <NoTasks>
            <NoTasksIcon>📅</NoTasksIcon>
            <NoTasksText>Нет задач на этот день</NoTasksText>
          </NoTasks>
        )}
      </TasksList>
    </Container>
  )
}

